import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import Grid from '@material-ui/core/Grid';
import '../../assets/css/Menu.css';
import CommonMenu from './CommonMenu'
import logo from '../../assets/images/logo.png';

const lang = '';

class Menu extends Component {
  constructor(props) {
    super(props);
    this.lang = (props.lang) ? props.lang : '';
  }

  getLangText(langJson) {
    return (this.lang) ? langJson[this.lang] : langJson['tc'];
  }

  getLink(page){
    if (page == '') {
      return (this.lang) ? '/' + this.lang : '/' + page;
    } else {
      return (this.lang) ? '/' + this.lang + '/' + page : '/' + page;
    }
  }

  render(){
    return(
      MenuJSX(this)
    );
  }
}

// The Header creates links that can be used to navigate
// between routes.
const MenuJSX = (ctx) => (    
    <div className="menu-home">
      <div style={{ position:'relative'}}>
        <div style={{ position:'relative', top:'0', width:'100%' }}>
          <Grid className="menu-home-container-parent" container>
            <Grid className="menu-home-container" container spacing={0} style={{ height:'80pt', lineHeight:'80pt' }}>
              <Grid className="grid-item-corp-logo-container" item xs={4} sm={4} style={{ height:'80pt', lineHeight:'80pt' }}>
                <Link to={ ctx.getLink('') } style={{ textDecoration: 'none'}}>
                  <img id="corp-logo" src={logo} style={{ display:'inline-block', verticalAlign:'middle' }} />
                </Link>
              </Grid>
              <Grid item xs={8} sm={8}>
                <CommonMenu lang={ ctx.lang } />
              </Grid>
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
)

export default Menu



// WEBPACK FOOTER //
// ./src/components/pages/includes/Menu.js